import { Injectable } from '@angular/core';

// Services
import { NavigationParam, RouteParam } from '../service-base';
import { TransactionServiceBase } from './abstract/transaction-service.base';

const CLASS_NAME = 'CreditCardTransaction';
const ENDPOINT = `/credit-card-transactions/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'account-entries', path: 'account-entries/', childClass: 'AccountEntryLine' },
    { key: 'potential-settlements', path: 'potential-settlements/', childClass: 'Settlement' },
    { key: 'settlements', path: 'settlements/', childClass: 'Settlement' },
]
const ROUTES: RouteParam[] = [
    { key: 'export', path: 'export/' },
    { key: 'massDelete', path: 'mass-delete/' },
]

@Injectable({
    providedIn: 'root'
})
export class CreditCardTransactionService extends TransactionServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }
}
